import React, { useContext } from 'react';

import { StyleSheet, TouchableHighlight, View } from 'react-native';
import DyteClient from '@dytesdk/web-core';
import { SvgXml } from 'react-native-svg';
import { defaultIconPack, IconPack } from '../lib/icons';
import { States } from '../types/props';
import { DyteI18n, useLanguage } from '../lib/lang';
import DyteText from './DyteText';
import { canViewPlugins } from '../utils/permissions';
import { DyteUIContext } from '../lib/context-provider/ui-context';

export default function ({
  meeting,
  size,
  states,
  variant,
  iconPack = defaultIconPack,
  t,
}: {
  meeting: DyteClient;
  size?: 'lg' | 'md' | 'sm' | 'xl';
  states?: States;
  variant?: 'button' | 'horizontal';
  iconPack?: IconPack;
  t?: DyteI18n;
}) {
  const defaultLang = useLanguage();
  t = t ?? defaultLang;
  iconPack = iconPack ?? defaultIconPack;
  const { storeStates, setStates } = useContext(DyteUIContext);
  const { colors } = storeStates.designSystem;
  states = states ?? storeStates;
  let buttonSize = 25;
  let buttonHorizontal = false;
  switch (size) {
    case 'md':
      buttonSize = 50;
      break;
    case 'lg':
      buttonSize = 100;
      break;
    case 'xl':
      buttonSize = 150;
      break;
  }
  switch (variant) {
    case 'horizontal':
      buttonHorizontal = true;
      break;
  }
  const styles = StyleSheet.create({
    panel: {
      flexDirection: 'row',
      paddingVertical: 12,
      paddingLeft: 48,
      justifyContent: 'flex-start',
      alignItems: 'center',
    },
    container: {
      alignItems: 'center',
      justifyContent: 'center',
    },
    button: {
      height: buttonSize * 2,
      width: '100%',
      backgroundColor: colors.background[1000],
    },
    text: {
      paddingHorizontal: 18,
      color: colors.text,
    },
  });
  if (!canViewPlugins(meeting)) return null;
  if (
    meeting.meta.viewType === 'WEBINAR' &&
    meeting.stage.status === 'OFF_STAGE'
  )
    return null;
  return (
    <View style={styles.container}>
      {buttonHorizontal && (
        <TouchableHighlight
          underlayColor={colors.background[800]}
          onPress={() => {
            setStates({
              ...states,
              activeSidebar: true,
              activeMoreMenu: false,
              sidebar: 'plugins',
            });
          }}
          style={styles.button}
        >
          <View style={styles.panel}>
            <SvgXml
              xml={iconPack.rocket.replace('currentColor', colors.text)}
              width={25}
              height={25}
            />
            <DyteText style={styles.text}>{t('plugins')}</DyteText>
          </View>
        </TouchableHighlight>
      )}
      {!buttonHorizontal && (
        <TouchableHighlight
          underlayColor={colors.background[800]}
          onPress={() => {
            setStates({
              ...states,
              activeSidebar: true,
              activeMoreMenu: false,
              sidebar: 'plugins',
            });
          }}
          style={styles.button}
        >
          <View style={styles.panel}>
            <SvgXml
              xml={iconPack.rocket.replace('currentColor', colors.text)}
              width={25}
              height={25}
            />
          </View>
        </TouchableHighlight>
      )}
    </View>
  );
}
